<script lang="ts" setup>
import { ref, computed, onMounted, watch } from 'vue';

import { scrollTop } from '@/utils';


const props = defineProps<{ performer?: any; }>();
const hourList = computed(() => {
    return props.performer.availability.match(/.{24}/g);;
});

</script>

<template src="./agenda.html"></template>
<style lang="scss">
@import './agenda.scss';
</style>
